import { c as _c } from "react/compiler-runtime";
import styled, { css, useTheme } from 'styled-components';
import Skeleton, { pulse_keyframe } from '../base/Skeleton';
import Text from '../base/Text';
import { Div } from '../helpers/StyledUtils';
import LegendColor from './LegendColor';
const StyledSkeletonChart = styled(Div)(() => css`
    display: flex;
    flex-direction: column;
    animation: ${pulse_keyframe} 1.5s ease-in-out 0.5s infinite;
  `);
const StyledGrid = styled(Div)<{
  columns: number;
}>(({
  columns
}) => css`
    display: grid;
    gap: 1px;
    grid-template-columns: repeat(${columns}, 1fr);
    width: 100%;
  `);
const StyledCell = styled.div(({
  theme
}) => css`
    width: 100%;
    height: 100%;
    border: 1px solid ${theme.colors.outline.neutral};

    &:nth-child(-n + 16) {
      border: 1px dashed ${theme.colors.outline.neutral};
      border-left: none;
      border-right: none;
    }
    &:nth-last-child(-n + 4) {
      border-top: 1px dashed ${theme.colors.outline.neutral};
    }
    border-left: none;
    border-right: none;
  `);
const SkeletonChart: React.FC<{
  type: 'bar' | 'line';
  legend_placeholder?: string;
  height: number;
}> = t0 => {
  const $ = _c(20);
  const {
    legend_placeholder,
    height
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== height) {
    t1 = {
      px: height
    };
    $[0] = height;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      x: 4,
      t: 3,
      b: 4
    };
    t3 = {
      direction: "column",
      grow: true
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      grow: true
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Div flex={t4}><StyledGrid columns={4}><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /><StyledCell /></StyledGrid></Div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      b: 1,
      t: 1
    };
    t7 = {
      px: 14
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Skeleton w={{
      px: 40
    }} h={{
      px: 14
    }} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Skeleton w={{
      px: 40
    }} h={{
      px: 14
    }} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Skeleton w={{
      px: 40
    }} h={{
      px: 14
    }} />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <StyledGrid columns={4} m={t6} h={t7}>{t8}{t9}{t10}<Skeleton w={{
        px: 40
      }} h={{
        px: 14
      }} /></StyledGrid>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== legend_placeholder || $[13] !== theme) {
    t12 = legend_placeholder && <Div flex={{
      justify: "space-between"
    }} p={{
      t: 2
    }}><Div p={{
        x: 1
      }} flex={{
        align: "center"
      }}><LegendColor color={theme.colors.outline.neutral} m={{
          r: 2
        }} /><Text mono={true} muted={true}>{legend_placeholder}</Text></Div></Div>;
    $[12] = legend_placeholder;
    $[13] = theme;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12) {
    t13 = <Div p={t2} flex={t3}>{t5}{t11}{t12}</Div>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t1 || $[18] !== t13) {
    t14 = <StyledSkeletonChart h={t1}>{t13}</StyledSkeletonChart>;
    $[17] = t1;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  return t14;
};
export default SkeletonChart;